module.exports = __webpack_public_path__ + "img/mysqldatabase.831bc3a7.png";